module.exports = __webpack_public_path__ + "media/images/no-image-845ba611a7dbdd873be85859eaf716437ab64c65954dbbf0cf66851a24c71e1a.png";